import { render, staticRenderFns } from "./Partenaire.vue?vue&type=template&id=6e6bc723&scoped=true&"
import script from "./Partenaire.vue?vue&type=script&lang=js&"
export * from "./Partenaire.vue?vue&type=script&lang=js&"
import style0 from "./Partenaire.vue?vue&type=style&index=0&id=6e6bc723&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6bc723",
  null
  
)

export default component.exports